import React, { Component } from "react";
import MyContext from './MyContext.jsx';

export default class MyProvider extends Component {
  constructor(props){
    super(props);
    var user_details = window.localStorage.getItem('user_details_alsafas_emak_app');
    user_details = user_details?JSON.parse(user_details):"";
    var magnified = window.localStorage.getItem('alsafas_app_magnified') === 'true';
    this.state = {
      version : "1.2.9",
      user_details : user_details,
      show_loading : 0,
      location : {},
      currency : 'OMR',
      magnified: magnified
    };
    this.handleAuthTokenUpdated = this.handleAuthTokenUpdated.bind(this);
  }

  componentDidMount() {
    window.addEventListener('auth_token_updated', this.handleAuthTokenUpdated);
    document.body.classList.toggle('app-magnified', this.state.magnified);
  }

  componentWillUnmount() {
    window.removeEventListener('auth_token_updated', this.handleAuthTokenUpdated);
  }

  handleAuthTokenUpdated(event) {
    if (event.detail) {
      this.setState({ user_details: event.detail });
    }
  }

  render() {
    return (
      <MyContext.Provider
          value={{
            version : this.state.version,
            currency : this.state.currency,
            user_details : this.state.user_details,
            setUserDetails : (data) => {
              this.setState({
                  user_details : data
              });
            },
            show_loading : this.state.show_loading,
            loading : (data) => {
              this.setState({
                  show_loading : data
              });
            },
            location : this.state.location,
            setLocation : (data) => {
              this.setState({
                location : data
              });
            },
            magnified : this.state.magnified,
            setMagnified : (data) => {
              this.setState({
                magnified : data
              }, () => {
                document.body.classList.toggle('app-magnified', data);
                window.localStorage.setItem('alsafas_app_magnified', data);
              });
            }
          }}
      >
          {this.props.children}
      </MyContext.Provider>
    );
  }
}